module.exports = __webpack_public_path__ + "img/C10.656894b7.svg";